import * as types from './colorActionTypes';

export const getColorRequestAction = (payload) => ({
  type: types.GET_COLOR_REQUEST,
  payload,
});

export const getColorDataAction = (payload) => ({
  type: types.GET_COLOR_DATA,
  payload,
});

export const getColorErrorAction = (payload) => ({
  type: types.GET_COLOR_ERROR,
  payload,
});

export const createColorRequestAction = (payload) => ({
  type: types.CREATE_COLOR_REQUEST,
  payload,
});

export const createColorDataAction = (payload) => ({
  type: types.CREATE_COLOR_DATA,
  payload,
});

export const createColorErrorAction = (payload) => ({
  type: types.CREATE_COLOR_ERROR,
  payload,
});

export const updateColorRequestAction = (payload) => ({
  type: types.UPDATE_COLOR_REQUEST,
  payload,
});

export const updateColorDataAction = (payload) => ({
  type: types.UPDATE_COLOR_DATA,
  payload,
});

export const updateColorErrorAction = (payload) => ({
  type: types.UPDATE_COLOR_ERROR,
  payload,
});

export const deleteColorRequestAction = (payload) => ({
  type: types.DELETE_COLOR_REQUEST,
  payload,
});

export const deleteColorDataAction = (payload) => ({
  type: types.DELETE_COLOR_DATA,
  payload,
});

export const deleteColorErrorAction = (payload) => ({
  type: types.DELETE_COLOR_ERROR,
  payload,
});
